/**
 * Charts API endpoints
 */

import { get, put } from './client';
import type { NatalChart } from '../types';

interface PrimaryChartResponse {
  chart: NatalChart | null;
}

export interface UpdatePrimaryChartData {
  birth_date: string;
  birth_time: string;
  birth_place: string;
}

/**
 * Get user's primary chart
 */
export async function getPrimaryChart(): Promise<NatalChart | null> {
  const data = await get<PrimaryChartResponse>('/api/charts/primary');
  return data.chart;
}

/**
 * Update user's primary chart
 */
export async function updatePrimaryChart(data: UpdatePrimaryChartData): Promise<NatalChart> {
  const response = await put<PrimaryChartResponse>('/api/charts/primary', data as unknown as Record<string, unknown>);
  return response.chart!;
}

/**
 * Geocode search result
 */
export interface GeocodeSuggestion {
  display_name: string;
  city: string;
  country: string;
  lat: number;
  lon: number;
}

/**
 * Search for cities (geocode autocomplete)
 */
export async function searchCities(query: string): Promise<GeocodeSuggestion[]> {
  if (!query || query.length < 2) return [];
  const response = await get<{ results: GeocodeSuggestion[] }>(`/api/geocode?q=${encodeURIComponent(query)}`);
  return response.results || [];
}
